export default "__VITE_ASSET__9a317004__"